import { Button, Divider, InputNumber, Typography } from "antd";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import { displayDollar, displayPercentage } from "utilities/tableUtility";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars-2";
import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import K from "../../../utilities/constants";
import { ConfirmDeleteBillingButton } from "./ConfirmDeleteBillingButton";

const { Paragraph, Title } = Typography;

export default function BillingDetails({
  type,
  billing,
  isEditMode,
  isReadOnly,
  toggleEdit,
  editAmount,
  isConverting,
  inputRef,
  convert,
  history,
  duplicateAmount,
  clientName = null,
  onDelete = null,
  showDeleteButton = false,
  showConvertButton = true,
}) {
  return (
    <>
      {clientName && <Title level={4}>{clientName}</Title>}
      <span className="clientBillingType">{billing?.billingTypeName}</span>
      <div className="clientBillingWrap">
        <div className="clientBillingTitle">
          <div className="clientBilling">
            <Title level={4}>ID:</Title>
            <Paragraph>{billing?.id}</Paragraph>
          </div>
          {type === K.BillingType.Job && (
            <>
              <div className="clientBilling">
                <Title level={4}>Candidate Name:</Title>
                <Paragraph>{billing?.candidateName}</Paragraph>
              </div>
              <div className="clientBilling">
                <Title level={4}>Job Title:</Title>
                <Paragraph>{billing?.jobTitle}</Paragraph>
              </div>
            </>
          )}
          <div className="clientBilling">
            <Title level={4}>Create Date:</Title>
            <Paragraph>{convertIntoDashUSFormat(billing?.createdAt)}</Paragraph>
          </div>
          <div className="clientBilling">
            <Title level={4}>Original Amount:</Title>
            <Paragraph>
              {[
                displayDollar(+billing?.amount.toFixed(2)),
                `(${billing?.currency})`,
              ].join(" ")}
            </Paragraph>
          </div>
          <div className="clientBilling billed-amount">
            {isEditMode ? (
              <div className="billingField">
                <Title level={4} className="orignalAmount">
                  Billed Amount:
                </Title>
                <InputNumber ref={inputRef} defaultValue={duplicateAmount ?? 0} />
                <Button
                  type="link"
                  onClick={toggleEdit}
                  icon={<CloseCircleOutlined className="closeIcon" />}
                />
                <Button
                  type="link"
                  onClick={editAmount}
                  icon={<CheckCircleOutlined className="checkIcon" />}
                />
              </div>
            ) : (
              <div>
                <Title level={4} className="orignalAmount">
                  Billed Amount:{" "}
                  <span className="cbOrignalAmount">
                    {[
                      displayDollar(+duplicateAmount?.toFixed(2)),
                      `(${billing?.convertToCurrency})`,
                    ].join(" ")}
                    {!isReadOnly && (
                      <Button
                        type="link"
                        onClick={toggleEdit}
                        icon={<i className="icon-edit" />}
                      />
                    )}
                  </span>
                </Title>
              </div>
            )}
            {showConvertButton && (
              <Button
                disabled={billing?.convertToCurrency === "USD" || !convert}
                type="primary"
                className="editAmountBtn"
                onClick={convert}
                loading={isConverting}
              >
                Convert Currency
              </Button>
            )}
          </div>
          {onDelete && showDeleteButton && (
            <ConfirmDeleteBillingButton onDelete={onDelete} className="mt-3" />
          )}
        </div>
      </div>

      {billing?.issueCreditReason && (
        <div className="clientBillingTitle">
          <div className="">
            <Title level={5} className="clientBilling orignalAmount">
              Issue Credit Reason:
            </Title>
            <Paragraph className="clientBilling clientOrignalAmount">
              {billing?.issueCreditReason}
            </Paragraph>
          </div>
        </div>
      )}

      <Divider className="divider" />
      <Title level={5} className="clientHistoryTitle">
        History
      </Title>
      <div className="clientHistoryWrap">
        <Scrollbars style={{ height: 460 }}>
          {history.length ? (
            history.map((item) => (
              <div key={item.id} className="clientHistoryDetail">
                <div className="clientAmountHistory">
                  <div className="clientName">
                    <Title level={5}>
                      {item.edit || item.discount >= 0
                        ? "Updated "
                        : "Converted "}
                      by:
                    </Title>
                    <Paragraph>{item.user?.name}</Paragraph>
                  </div>
                  <div className="clientDate">
                    <Title level={5}>Updated at:</Title>
                    <Paragraph>
                      {convertIntoDashUSFormat(item.createdAt)}
                    </Paragraph>
                  </div>
                </div>
                <Divider className="historyDivider" />
                <div className="clientAmount">
                  <Title level={5}>
                    Billed Amount:{" "}
                    {`${displayDollar(item.billingAmount)} (${item.code})`}
                  </Title>
                  {!item.edit && item.conversionRate && (
                    <Paragraph>
                      Conversion Rate: {item.conversionRate?.toFixed(3)}
                    </Paragraph>
                  )}
                  {item.discount >= 0 && (
                    <>
                      <Paragraph>
                        Discount Rate:
                        {displayPercentage(item.discountPercentage)}
                      </Paragraph>
                      <Paragraph>
                        Discounted Amount: {displayDollar(item.discount)}
                      </Paragraph>
                    </>
                  )}
                </div>
              </div>
            ))
          ) : (
            <EmptyPlaceholder />
          )}
        </Scrollbars>
      </div>
    </>
  );
}
